import { Component, OnInit, ViewChild, AfterContentInit, ElementRef, Output, EventEmitter, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';
import { ProjectionInfoComponent } from '../projection-info/projection-info.component';
import { ButtonGroupComponent } from '../button-group/button-group.component';
import { ActionGroupComponent } from '../action-group/action-group.component';

@Component({
  selector: 'app-projection-uploader',
  templateUrl: './projection-uploader.component.html',
  styleUrls: ['./projection-uploader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectionUploaderComponent implements AfterContentInit {

  @Input()
  public prjText = '';
  @Output()
  public prjTextChange: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('dropArea', { static: true }) dropArea: ElementRef;
  @ViewChild('prjTextArea', { static: true }) prjTextArea: ElementRef;
  @ViewChild('prjInfo', { static: true }) prjInfo: ProjectionInfoComponent;
  @ViewChild('viewGroup', { static: true }) viewGroup: ActionGroupComponent;

  private _prjJson: any = {};
  @Input('prjJson')
  public set prjJson(json: any) {
    if(JSON.stringify(json) === JSON.stringify(this._prjJson)) {
      return;
    }
    this._prjJson = json;
    this.prjJsonChange.emit(this._prjJson);
  }
  public get prjJson(): any {
    return this._prjJson;
  }
  @Output()
  public prjJsonChange = new EventEmitter<any>();
  showText = true;
  showInfo = false;

  constructor(private changes: ChangeDetectorRef, private messager: ModalMessagerService) { }

  ngAfterContentInit() {
    const me = this;
    this.prjTextArea.nativeElement.ondrop = (e) => {
      e.preventDefault();
      const file = e.dataTransfer.files[0];
      if (file.name.split('.').pop() !== 'prj') {
        alert('not a prj file');
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        this.prjText = e.target.result as string;
        if (this.ValidatePrj()) {
          this.prjTextChange.emit(me.prjText);
        } else {
          this.prjText = '';
        }
      };
      reader.readAsText(file, 'UTF-8');
      this.changes.detectChanges();
    }
    window.requestAnimationFrame(() => {
      this.ShowText(true);
    })

  };
  ShowText(toggle = false) {
    this.showText = true;
    this.showInfo = false;

    this.viewGroup.SetSelected('Show prj format', true);
    this.changes.detectChanges();

  }
  ShowInfo(toggle = false) {
    this.showText = false;
    this.showInfo = true;

    this.viewGroup.SetSelected('Show projection info', true);
    this.changes.detectChanges();

  }
  RequestUpload() {
    this.messager.RequestImport(
      {
        acceptedExtentions: ['prj'],
        encoding: 'text/plain',
        readType: 'text'
      }, 'Choose a .prj file to continue.',
      (response: any) => {
        this.prjText = response.contents;
        if (this.ValidatePrj()) {
          this.prjTextChange.emit(this.prjText);
        } else {
          this.prjText = '';
        }
        this.changes.detectChanges();
      }, (problem) => {
        console.log('Import Request Problem', problem);
      }, 'Prj Import'
    );
  }
  PasteSRS() {
    const text = navigator.clipboard.readText().then((result) => {
      if (!result) {
        return;
      }
      this.SetSRS(result);

    });

  }
  SetSRS(srs: string) {
    this.prjText = srs.trim();
    if (this.ValidatePrj()) {
      this.prjTextChange.emit(this.prjText);
    } else {
      this.prjText = '';
    }
    this.changes.detectChanges();
  }
  ValidatePrj(): boolean {
    const prjParts = this.prjText.toLowerCase().split('[');
    const firstPart = prjParts.shift();
    if (['projcs', 'geogcs'].indexOf(firstPart) < 0) {
      this.prjText = '';
    }
    if (this.prjText === '') {
      return false;
    }
    this.prjInfo.SetPRJ(this.prjText);
    this.ShowInfo(true);

    return true;
  }
  ManualChange(event) {
    if (event.target.value === '') {
      this.SetSRS(event.target.value);
    }
    if (!!event.which) {
      const characterCode = event.which;
      if (characterCode === 13) {
        this.SetSRS(event.target.value);
      }
    }

  }
}
